(function () {
    /*jshint camelcase: false */
    'use strict';

    angular
        .module('josdaviApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$rootScope', '$http', '$localStorage', 'Base64'];

    function AuthServerProvider($rootScope, $http, $localStorage, Base64) {
        var service = {
            getToken: getToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken() {
            console.log("Getting token");
            return $localStorage.authenticationToken;
        }

        function login(credentials) {
            var data = 'username=' + encodeURIComponent(credentials.username) + '&password=' +
                encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
                'client_secret=my-secret-token-to-change-in-production&client_id=josdaviapp';

            return $http.post('oauth/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + Base64.encode('josdaviapp' + ':' + 'my-secret-token-to-change-in-production')
                }
            }).success(authSucess);

            function authSucess(response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = response;
                $rootScope.$broadcast('onLoginSuccess');
                return response;
            }
        }

        function logout() {
            $http.post('api/logout').then(function () {
                delete $localStorage.authenticationToken;
                $rootScope.$broadcast('onLogoutSuccess');
            });
        }
    }
})();
